export default __webpack_public_path__ + "afb564ba295df71d32bbd5a92763688d.svg";